<template>
    <p class="holderModalContent" v-html="content"></p>
</template>
<script>
    export default {
        name: 'DefaultModalContent',
        props:{
            content:{ type: String},
        }   
    }
</script>
<style lang="scss">
    .holderModalContent{ padding-top: 2rem;
        & > b,
        & > b > *{ font-family: $bold !important;}
    }
</style>